<template>
  <div class="animated fadeIn">

    <b-card header="Business Metrics" v-if="loading.util || loading.employee">Loading, please wait...</b-card>
    <b-card header="Business Metrics" v-else>
      <b-card-group class="mb-4">
        <b-card>
          <div class="h4 mb-0">{{Number(this.cards.backlog).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</div>
          <small class="text-muted text-uppercase font-weight-bold">Backlog (Bookings Remaining)<br>(Current)</small>
        </b-card>
        <b-card>
          <div class="h4 mb-0">{{Number(this.cards.utilization).toFixed(2) + '%'}}</div>
          <small class="text-muted text-uppercase font-weight-bold">Utilization<br>(Last Week)</small>
        </b-card>
        <b-card>
          <div class="h4 mb-0">{{Number(this.cards.overrun).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</div>
          <small class="text-muted text-uppercase font-weight-bold">Underrun or Overrun<br>(Last Week)</small>
        </b-card>
        <b-card>
          <div class="h4 mb-0">{{Number(this.cards.revenue).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</div>
          <small class="text-muted text-uppercase font-weight-bold">Earned Revenue<br>(Last Week)</small>
        </b-card>
        <b-card>
          <div class="h4 mb-0">{{Number(this.cards.revenue_per_billable_employee).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</div>
          <small class="text-muted text-uppercase font-weight-bold">Earned Revenue Per<br>Billable Employee (Last Week)</small>
        </b-card>
      </b-card-group>
      <div><b-button-toolbar>
        <b-input-group>
          <b-form-select id="displaySelection" :options="['Weekly Metrics on Table','Select Metric to Graph']" v-model="currentSelection.display" v-on:change="displayChanged"></b-form-select>
        </b-input-group>
				<div class="small-space">&nbsp;&nbsp;&nbsp;</div>
        <b-input-group>
          <b-form-input type="date" id="selectedStartDate" v-model="currentSelection.startDate"></b-form-input>
        </b-input-group>
        <div class="small-space">&nbsp;</div>
        <div class="small-text">to</div>
        <div class="small-space">&nbsp;</div>
        <b-input-group>
          <b-form-input type="date" id="selectedEndDate" v-model="currentSelection.endDate"></b-form-input>
        </b-input-group>
        <div class="small-space">&nbsp;</div>
        <b-input-group>
          <!--<b-button-group class="mx-2">-->
            <b-button id="filterButton" variant="secondary" v-on:click="filterClicked">Set Dates</b-button>
          <!--</b-button-group>-->
        </b-input-group>
      </b-button-toolbar></div>
      <br>
      <div v-if="currentSelection.display == 'Select Metric to Graph'"><b-button-toolbar>
        <b-input-group>
          <b-form-select id="metricSelection" :options="['Utilization','Cost Overrun','Earned Revenue','Earned Revenue per Billable Employee']" v-model="currentSelection.metric" v-on:change="metricChanged"></b-form-select>
        </b-input-group>
        <div class="small-space">&nbsp;&nbsp;&nbsp;</div>
        <b-input-group v-if="currentSelection.metric == 'Utilization'">
          <b-form-select id="employeeSelection" :options="employeeOptions" v-model="currentSelection.employee" v-on:change="employeeChanged"></b-form-select>
        </b-input-group>
      </b-button-toolbar></div>

      <div v-if="currentSelection.display == 'Weekly Metrics on Table'">
        <b-table hover="true" striped="true" bordered="true" small="true" responsive="md" :items="items" :fields="fields" sort-by="week" sort-desc="true" :current-page="currentSelection.currentPage" per-page="100">
          
          <template slot="week" slot-scope="data">
              {{data.item.week}}
          </template>

          <template slot="utilization" slot-scope="data">
              {{Number(data.item.utilization).toFixed(2) + '%'}}
          </template>

          <template slot="overrun" slot-scope="data">
              {{Number(data.item.overrun).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
          </template>

          <template slot="revenue" slot-scope="data">
              {{Number(data.item.revenue).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
          </template>

          <template slot="revenue_per_billable_employee" slot-scope="data">
              {{Number(data.item.revenue_per_billable_employee).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
          </template>

          <template slot="bottom-row" slot-scope="data">
            <td><strong>Total</strong></td>
            <td><strong>{{utilFooter.avg == null ? '--' : (utilFooter.avg.toFixed(2)) + '%'}}</strong></td>
            <td><strong>{{calculateTotal('overrun').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</strong></td>
            <td><strong>{{calculateTotal('revenue').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</strong></td>
            <td><strong>{{calculateTotal('revenue_per_billable_employee').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</strong></td>
          </template>
          
        </b-table>
        <nav v-if="(items.length > 100)" >
          <b-pagination :total-rows="items.length" per-page="100" v-model="currentSelection.currentPage"/>
        </nav>
      </div>

      <div v-if="currentSelection.display == 'Select Metric to Graph'">
        <main-chart-example chartId="main-chart-01" class="chart-wrapper" style="height:300px;margin-top:40px;" height="300" :chartdata="projectReportChartData" :options="projectReportChartOptions"></main-chart-example>
        <br>

        <div slot="footer">
          <b-row class="text-center">
            <b-col class="mb-sm-2 mb-0 d-md-down-none">
            </b-col>
            <b-col class="mb-sm-2 mb-0 d-md-down-none">
            </b-col>
            <b-col class="mb-sm-2 mb-0">
              <div class="text-muted">{{this.footer.name}}</div>
              <strong>{{this.footer.value}}</strong>
            </b-col>
            <b-col class="mb-sm-2 mb-0 d-md-down-none">
            </b-col>
            <b-col class="mb-sm-2 mb-0 d-md-down-none">
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  <!--TODO: this is only for debugging, remove when done-->
  <!--{{this.items}}-->
  <!--
  {{this.projectReportChartData}}
  -->
  </div>
</template>

<script>
import MainChartExample from './MainChart'
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import axios from 'axios'

export default {
  name: 'utilization',
  components: {
    MainChartExample,
  },
  data: function () {
    return {
      employeeOptions: [
        //{value: <email>, text: <name>}
        {value: 'Entire Organization', text: 'Entire Organization'}
      ],
      cards: {
        backlog: null,
        utilization: null,
        overrun: null,
        revenue: null,
        revenue_per_billable_employee: null
      },
      utilFooter: {
        avg: null
      },
      footer: {
        name: '',
        value: null
      },
			currentSelection: {
        employee: 'Entire Organization',
        startDate: '',
        endDate: '',
        display: 'Weekly Metrics on Table',
        metric: 'Utilization',
        currentPage: 1
			},
			currentUser: {
				cognitoUser: null,
				email: '',
				role: '',
				company: '',
				token: ''
			},
			loading: {
        util: true,
        employee: true
      },

			items: [
				//{week: '', utilization: 0, overrun: 0, revenue: 0, revenue_per_billable_employee: 0}
			],

			fields: {
				week: {label: 'Week<br>&nbsp;', sortable: true, thStyle: {width: '100px'}},
				utilization: {label: 'Utilization<br>&nbsp;', sortable: true, thStyle: {width: '100px'}},
				overrun: {label: 'Underrun or Overrun<br>&nbsp;', sortable: true, thStyle: {width: '100px'}},
				revenue: {label: 'Earned Revenue<br>&nbsp;', sortable: true, thStyle: {width: '100px'}},
				revenue_per_billable_employee: {label: 'Earned Revenue<br>Per Billable Employee', sortable: true, thStyle: {width: '100px'}},
			},

      projectReportChartData: {},

      projectReportChartDataTemplate: {
        labels: [],
        datasets: [
          {
            label: 'Utilization',
            fill: false,
            backgroundColor: '#20a8d8',
            borderColor: '#20a8d8',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            lineTension: 0,
            data: []
          }
          
        ]
      },
      projectReportChartOptions: {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              //maxTicksLimit: 5,
              //stepSize: Math.ceil(250 / 5),
              max: 100,
              callback: function(value, index, values) {
                  return value.toFixed(0) + '%';
              }
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 3,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }

    }
  },

  mounted() {

		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentUser.cognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					vueInstance.currentUser.token = session.getIdToken().getJwtToken();
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}

						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "custom:company")
								vueInstance.currentUser.company = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.currentUser.role = result[i].getValue();
							else if (result[i].getName() == "email")
								vueInstance.currentUser.email = result[i].getValue();
						}

            var today = new Date();
            var lastQ = new Date();
            lastQ.setMonth(lastQ.getMonth() - 3);
            vueInstance.currentSelection.startDate = lastQ.toISOString().substring(0,10);
            vueInstance.currentSelection.endDate = today.toISOString().substring(0,10);

						vueInstance.loading.employee = true;
						axios.get('/user-admin/active-employee-list', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
                vueInstance.employeeOptions = JSON.parse(JSON.stringify(response.data));
                vueInstance.employeeOptions.unshift({value:'Entire Organization',text:'Entire Organization'});
								vueInstance.loading.employee = false;
							})
							.catch(function (error) {
              });

            vueInstance.updateData(vueInstance.currentSelection.employee, vueInstance.currentSelection.startDate, vueInstance.currentSelection.endDate)

					});
				}

			});
		}

  },

  methods: {
		employeeChanged: function (event) {
			document.getElementById("employeeSelection").blur();
      this.currentSelection.employee = event;		//TODO: this line is needed because somehow v-model doesn't work, need to find out why

      this.updateData(event, this.currentSelection.startDate, this.currentSelection.endDate)
    },

		filterClicked: function (event) {
      document.getElementById("filterButton").blur();
      this.updateData(this.currentSelection.employee, this.currentSelection.startDate, this.currentSelection.endDate)
    },

		displayChanged: function (event) {
			document.getElementById("displaySelection").blur();
      this.currentSelection.display = event;		//TODO: this line is needed because somehow v-model doesn't work, need to find out why

      if ((event == 'Weekly Metrics on Table') && (this.currentSelection.employee != 'Entire Organization')) {
        this.currentSelection.employee = 'Entire Organization'
        this.updateData('Entire Organization', this.currentSelection.startDate, this.currentSelection.endDate)
      }

    },

		metricChanged: function (event) {
			document.getElementById("metricSelection").blur();
      this.currentSelection.metric = event;		//TODO: this line is needed because somehow v-model doesn't work, need to find out why

      this.updateChart(event)
    },

    updateData (employee, startDate, endDate) {

      var vueInstance = this;
      
			if ((startDate == '') || (endDate == '') || (startDate > endDate)) {
        vueInstance.items = []
        vueInstance.cards = {backlog: null, utilization: null, overrun: null, revenue: null, revenue_per_billable_employee: null}
        vueInstance.utilFooter.avg = null
        vueInstance.updateChart(vueInstance.currentSelection.metric)
			}
			else {
        vueInstance.loading.util = true;

				var startDateObject = new Date(Number(startDate.substring(0,4)), Number(startDate.substring(5,7))-1, Number(startDate.substring(8,10)));
				var endDateObject = new Date(Number(endDate.substring(0,4)), Number(endDate.substring(5,7))-1, Number(endDate.substring(8,10)));
        startDateObject.setDate(startDateObject.getDate() - (startDateObject.getDay() == 0 ? 6 : (startDateObject.getDay() - 1)));

        vueInstance.items = []
        for (var i = startDateObject; i <= endDateObject; i.setDate(i.getDate() + 7)) {
          vueInstance.items.push({week: i.toISOString().substring(0,10), utilization: 0, overrun: 0, revenue: 0, revenue_per_billable_employee: 0})
        }

        axios.get('/report/utilization', {params:{token:vueInstance.currentUser.token, employee:employee, startDate: vueInstance.items[0].week, endDate: vueInstance.items[vueInstance.items.length - 1].week}})
          .then(function (response) {
            for (var j = 0; j < vueInstance.items.length; j++) {
              vueInstance.items[j].utilization = Number(response.data.y[j])
              vueInstance.items[j].overrun = Number(response.data.overrun[j])
              vueInstance.items[j].revenue = Number(response.data.revenue[j])
              vueInstance.items[j].revenue_per_billable_employee = Number(response.data.revenue_per_billable_employee[j])
            }
            vueInstance.cards = JSON.parse(JSON.stringify(response.data.cards))
            vueInstance.utilFooter.avg = JSON.parse(JSON.stringify(response.data.avg))
            vueInstance.updateChart(vueInstance.currentSelection.metric);
            vueInstance.loading.util = false;
					})
					.catch(function (error) {
            vueInstance.items = []
            vueInstance.cards = {backlog: null, utilization: null, overrun: null, revenue: null, revenue_per_billable_employee: null}
            vueInstance.utilFooter.avg = null
            vueInstance.updateChart(vueInstance.currentSelection.metric);
            vueInstance.loading.util = false;
          });
          
      }

		},

    updateChart (metric) {

      var vueInstance = this;
      
        vueInstance.projectReportChartDataTemplate.labels = []
        vueInstance.projectReportChartDataTemplate.datasets[0].data = []

        /*
        this.projectReportChartDataTemplate.labels = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
        this.projectReportChartDataTemplate.datasets[0].data = [20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20]
        */

        for (var i = 0; i < vueInstance.items.length; i++) {
          vueInstance.projectReportChartDataTemplate.labels.push (vueInstance.items[i].week)
        }

        if (metric == 'Utilization') {
          vueInstance.projectReportChartDataTemplate.datasets[0].label = 'Utilization'
          for (i = 0; i < vueInstance.items.length; i++) {
            vueInstance.projectReportChartDataTemplate.datasets[0].data.push (vueInstance.items[i].utilization)
          }
        }
        if (metric == 'Cost Overrun') {
          vueInstance.projectReportChartDataTemplate.datasets[0].label = 'Cost Overrun'
          for (i = 0; i < vueInstance.items.length; i++) {
            vueInstance.projectReportChartDataTemplate.datasets[0].data.push (vueInstance.items[i].overrun)
          }
        }
        if (metric == 'Earned Revenue') {
          vueInstance.projectReportChartDataTemplate.datasets[0].label = 'Earned Revenue'
          for (i = 0; i < vueInstance.items.length; i++) {
            vueInstance.projectReportChartDataTemplate.datasets[0].data.push (vueInstance.items[i].revenue)
          }
        }
        if (metric == 'Earned Revenue per Billable Employee') {
          vueInstance.projectReportChartDataTemplate.datasets[0].label = 'Earned Value per Billable Employee'
          for (i = 0; i < vueInstance.items.length; i++) {
            vueInstance.projectReportChartDataTemplate.datasets[0].data.push (vueInstance.items[i].revenue_per_billable_employee)
          }
        }

        vueInstance.projectReportChartData = JSON.parse(JSON.stringify(vueInstance.projectReportChartDataTemplate))

        if (metric == 'Utilization') {
          vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.beginAtZero = true
          vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.callback = function(value, index, values) {return value.toFixed(0) + '%';}

          var maxUtil = Math.max.apply(null, vueInstance.projectReportChartDataTemplate.datasets[0].data)
          if (maxUtil > 100) {
            vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.max = (Math.ceil(maxUtil / 10) * 10)
          }
          else {
            vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.max = 100
          }

          vueInstance.footer.name = 'Overall Utilization'
          vueInstance.footer.value = (vueInstance.utilFooter.avg == null ? '--' : (vueInstance.utilFooter.avg.toFixed(2)) + '%')
        }
        else {
          vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.beginAtZero = false
          vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.callback = function(value, index, values) {return value.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0});}

          delete vueInstance.projectReportChartOptions.scales.yAxes[0].ticks.max

          vueInstance.footer.name = ('Total ' + metric)
          if (metric == 'Cost Overrun')
            vueInstance.footer.value = vueInstance.calculateTotal('overrun').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})
          else if (metric == 'Earned Revenue')
            vueInstance.footer.value = vueInstance.calculateTotal('revenue').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})
          else if (metric == 'Earned Revenue per Billable Employee')
            vueInstance.footer.value = vueInstance.calculateTotal('revenue_per_billable_employee').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})
            
        }

        
		},

		calculateTotal (column) {
			var total = 0;
			if (column == 'overrun') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].overrun)
				}
			}
			else if (column == 'revenue') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].revenue)
				}
			}
			else if (column == 'revenue_per_billable_employee') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].revenue_per_billable_employee)
				}
			}
			return total;
		}

  }
}
</script>

<style>

.small-space { font-size: 20px; }

.small-text { padding-top: 5px; }

input[type=date]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}

</style>
